import { createFilterObj } from "./filterUtils.js";
import dayjs from "dayjs";

export function createLoadGraphFilters(rows) {
  const current_datetime = dayjs();
  const filters = {
    "GroupFilter": createFilterObj({
      name: "GroupFilter",
      filteredPropertyName: "group",
      target: "グループ",
    }),
    "ResCodeFilter": createFilterObj({
      name: "ResCodeFilter",
      filteredPropertyName: "resourceCode",
      target: "資源コード",
    }),
    "ProcessFilter": createFilterObj({
      name: "ProcessFilter",
      filteredPropertyName: "process",
      target: "工程",
    }),
    "ShiftFilter": createFilterObj({
      name: "ShiftFilter",
      filteredPropertyName: "shift",
      target: "勤務シフト",
    }),
  }
  for (const key in filters) {
    filters[key].items = filters[key].getFilterItems(rows, {[key]: filters[key]})
  }
  return filters
}